import Axios from 'axios';
import {
  validToken,
  getOrganization,
  getRefreshToken,
  setToken,
  getRole
} from './AuthHelper';
import { restPath, restSeebizPath } from './UrlHelper';
import { handleRedirectIfNotFound } from '../Api/Invoice/Utils';
import { getObjFromLS } from './LocalStorage';

const requestWithToken = Axios.create();
requestWithToken.interceptors.response.use(
  function (response) {
    const refreshedToken = response.headers.authorization;
    if (refreshedToken) {
      setToken(refreshedToken);
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export function restRequest(method, path, data = {}) {
  const headers = {
    'Cache-Control': 'no-cache',
    Expires: '-1',
    Pragma: 'no-cache',
    'Cache-Control': 'max-age=0',
    Expires: 'Tue, 01 Jan 1980 11:00:00 GMT',
    authorization: validToken(),
    refresh_token: getRefreshToken(),
  };
  const isFormData = data instanceof FormData;
  if (!isFormData) {
    headers['Content-Type'] = 'application/json; charset=UTF-8';
  } else {
    headers['Content-Type'] = 'multipart/form-data; charset=UTF-8';
  }
  if (getOrganization()) {
    headers['organization'] = getOrganization();
  }
  return requestWithToken({
    method,
    url: restPath(path),
    data,
    headers,
  })
    .then((res) => {
      if (res.status === 202 && res.data.message === 'Business access denied') {
        sessionStorage.setItem('OrganizationReadOnly', true);
        window.location.href = '/packagesplan';
        return {};
      }
      return res.data;
    })
    .catch(async (error) => {
      if (error) {
        let role = getRole();
        let user = getObjFromLS('currentUser')
        // console.log('API Error Role:', user)
        // let user = JSON.parse(localStorage.getItem('currentUser')) || {};
        // console.log('API Error:', user)
        try {
          await requestWithToken({
            url: restPath('response/logs'),
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'organization': getOrganization(),
              Authorization: validToken(),
              refresh_token: getRefreshToken(), // ✅ fixed
            },
            data: {
              method,
              url: restPath(path),
              data,
              headers: {
                userid: user?.id || null,
                organization: headers?.organization || null
              },
              error: {
                message: error?.message || null,
                // stack: error.stack,
                response: error?.response?.data || null
              }
            }
          });

          // console.log('Logged API error successfully');
        } catch (err) {
          console.error('Error logging API error:', err);
          // window.location.replace('/');
        }
      }
      const message = error?.response?.data?.message;
      handleRedirectIfNotFound(message); // no history in global scope
      return Promise.reject(error);
    });
}

export function publicRequest(method, path, data = {}) {
  return Axios({
    method: method,
    url: restPath(path),
    data: data,
  }).then((res) => {
    return res.data;
  });
}

export function publicSeebizRequest(method, path, data = {}) {
  return Axios({
    method: method,
    url: restSeebizPath(path),
    data: data,
  }).then((res) => {
    return res.data;
  });
}

export function imagePathS3(imagePath, type = 'all') {
  if (!imagePath) {
    if (type === 'user') {
      return `${process.env.REACT_APP_AMAZON_S3}/media/default-user-image-placeholder.svg`;
    } else {
      return `${process.env.REACT_APP_AMAZON_S3}/media/image-placeholder.svg`;
    }
  }
  return `${process.env.REACT_APP_AMAZON_S3}/${imagePath}`;
}

export function imagePath(imagePath, type = 'all') {
  if (imagePath) {
    if (
      imagePath.match(
        /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i
      )
    )
      return imagePath;
  }

  return imagePathS3(imagePath, type);
}
